import customAxios from './api/interceptors'

export const getAllNotifications = ():Promise<any> => customAxios.get('company/notifications')

export const setSingleNotification = (id:number) => customAxios.put(`company/notifications/${id}`, { seen: '1' })

export const clearAllNotifications = () => customAxios.post(`/company/notification/close-all`)
